module.exports = __webpack_public_path__ + "img/angel-majuscules.9279a74a.jpg";